

import React from 'react';
import ServiceForm from '../components/ServiceForm';
import { CodeHighlighter } from '../components/CodeHighlighter';


const serviceEndpoint = "season/%sid/idp/assessments";

const serviceArguments = []

const serviceUrlArguments = [
  { name: 'sid', type: 'numeric',  mandatory: true, default: '', description: 'Season ID'},
]

const serviceSample = {}


export function IDPAssessments() {
  return <IDPAssessmentsComponent/>;
}


class IDPAssessmentsComponent extends React.Component {

  render() {

        return (
            <div>
                  <h3>Individual Development Plan Assessments</h3>

                  <p>Endpoint: <b>{serviceEndpoint}</b></p>

                  <p>
                    This service can be used to get the list of individual development plan assessments of a player.<br/>
                    This service can be invoked only by a player and will get the list of assessments for the player himself.<br/>
                    The assessment JSON includes all the metadata of the questions included in the assessment.<br/>
                    The user is supposed to fill the assessments of type 1 (Player assessment), which have a null or empty field "submitted_by_player_on".<br/>
                    The player should be notified of the presence of pending assessments to be filled.<br/>
                    An assessment can be related to an even.
                  </p>
                  <table className="table table-striped table-bordered table-hover">
                    <tbody><tr>
                        <th>Related event type</th>
                        <td>
                            match = Match<br/>
                            training-session = A regular "team" training session<br/>
                            training-session-idp = An individual training session<br/>
                            generic = A generic event<br/>
                            activity = A special event specific to individual plans<br/>
                        </td>
                      </tr>
                  </tbody></table>

                  <table className="table table-striped table-bordered table-hover">
                    <tbody><tr>
                        <th>assessment_type</th>
                        <td>
                          0 = Coach (not provided if the player does not have permissions to see coach assessments)<br/>
                          1 = Player<br/>
                        </td>
                      </tr>
                  </tbody></table>

                  If the evaluation template is not specified, the assessment is a simple text comment, stored in the field <i>evaluation_text</i> which should be shown only as alternative.<br/>
                  <p>
                    An example of assessments JSON array:
                  </p>
                  <CodeHighlighter code={ [
  {
    "id": "12",
    "pid": "2282899",
    "plan_id": "1",
    "title": "Please write your comment",
    "content": "",
    "assessment_type": "1",
    "is_private": "0",
    "ref_type": "activity",
    "ref_id": "8",
    "assessment_date": "2025-08-21 12:00:00",
    "submitted_by_player_on": "2025-08-24 23:59:28",
    "template": false,
    "event": {
      "nid": "8",
      "time": "01:57",
      "type": "activity",
      "icon": "icon-bubble",
      "title": "a6",
      "start": "2025-08-10 01:57:00",
      "className": "yc-label-pink cal-activity-event",
      "url": "https://local.youcoach.it/mycoach/season/2282875/players/2282899/idp?plan=1"
    }
  },
  {
    "id": "9",
    "pid": "2282899",
    "plan_id": "1",
    "title": "Valuta l'allenamento",
    "content": "Descrivi come ti é sembrato...",
    "assessment_type": "1",
    "is_private": "0",
    "ref_type": "training-session-idp",
    "ref_id": "2283253",
    "assessment_date": "2025-08-20 12:00:00",
    "submitted_by_player_on": "2025-08-25 00:05:23",
    "template": {
      "id": "68a2202db31af",
      "name": "Scheda Generale",
      "description": "Scheda di valutazione generale del calciatore",
      "created": "2025-08-17 20:32:13",
      "updated": "2025-08-17 20:32:13",
      "sections": [
        {
          "title": "Area Tecnica",
          "description": "Valutazione degli aspetti tecnici che considera la capacità di eseguire il gesto in modalità analitica",
          "items": [
            {
              "id": "AT1",
              "label": "Dominio piede destro",
              "item_type": "1-10"
            },
            {
              "id": "AT10",
              "label": "Rimessa laterale",
              "item_type": "1-10"
            }
          ]
        },
        {
          "title": "Area Tattica Offensiva",
          "description": "Valutazione delle conoscenze degli aspetti di tattica individuale offensiva",
          "items": [
            {
              "id": "ATO1",
              "label": "Duello offensivo",
              "item_type": "1-10"
            },
            {
              "id": "ATO2",
              "label": "Smarcamento",
              "item_type": "1-10"
            }
          ]
        }
      ],
      "hash": "111030b4108c49870f53439614507cde"
    },
    "event": {
      "nid": "2283253",
      "time": "19:49",
      "type": "training-session-idp",
      "icon": "icon-yc yc-icon-allenamento",
      "title": "Individual Training Session",
      "start": "2025-08-14T19:49:00",
      "className": "yc-label-purple cal-training-session-idp-event",
      "url": "https://local.youcoach.it/mycoach/season/2282875/training-sessions/2283253"
    }
  }
]
                  }/>


                  <ServiceForm
                        args={serviceArguments}
                        urlArgs={serviceUrlArguments}
                        sample={serviceSample}
                        endpoint={serviceEndpoint}
                        authRequired={true}
                        usePayload={false}
                  />

                  <h4>Request</h4>
                  <p>
                    Empty POST or GET
                  </p>
                  <h4>Response</h4>
                  <p>
                    A JSON with the list of assessments.
                  </p>
                  
            </div>
        );
  }


} 